import { Head } from '@inertiajs/react'
import Button from '../../Components/Button'
import IconBadge from '../GuestOrder/Components/IconBadge'
import PhoneButton from '../../Components/PhoneButton'
import Layout from './Layout'
import { formatDate, formatPrice } from './utils/formatters'

export default function Confirmation({ account, is_enquiry, reference, submission, meta }) {

  return (
    <>
      <Head title={meta.title} />
      <Layout account={account}>
        <div className="px-4 pt-24 pb-8 text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            {is_enquiry ? (
              <IconBadge label="Enquiry submitted" color="bg-green-500">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </IconBadge>
            ) : (
              <IconBadge label="Booking confirmed" color="bg-sky-500">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </IconBadge>
            )}
          </div>

          <h1 className="text-2xl font-bold text-white mb-2">
            {is_enquiry ? 'Enquiry Submitted' : 'Booking Confirmed'}
          </h1>
          <p className="text-sky-200 mb-1">
            {is_enquiry
              ? "We'll be in touch soon to discuss your event."
              : 'Your venue booking has been confirmed.'
            }
          </p>
          <p className="text-white font-mono text-sm bg-white/10 inline-block px-3 py-1 rounded-full mt-2 mb-6">
            Ref: {reference}
          </p>
        </div>

        {/* Submission Summary */}
        <div className="px-4">
          <section className="bg-white rounded-xl p-6" aria-label="Submission details">
            <h2 className="text-lg font-bold text-gray-900 mb-4">
              {is_enquiry ? 'Enquiry Details' : 'Booking Details'}
            </h2>
            <dl className="space-y-3 text-sm">
              {submission.event_type_name && (
                <div className="flex justify-between gap-4">
                  <dt className="text-gray-600 flex-shrink-0">Occasion</dt>
                  <dd className="font-medium text-gray-900 text-right">{submission.event_type_name}</dd>
                </div>
              )}
              <div className="flex justify-between gap-4">
                <dt className="text-gray-600 flex-shrink-0">Name</dt>
                <dd className="font-medium text-gray-900 text-right">{submission.guest_name}</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-gray-600 flex-shrink-0">Email</dt>
                <dd className="font-medium text-gray-900 text-right break-all">{submission.guest_email}</dd>
              </div>
              {submission.data?.package_name && (
                <div className="flex justify-between gap-4">
                  <dt className="text-gray-600 flex-shrink-0">Package</dt>
                  <dd className="font-medium text-gray-900 text-right">{submission.data.package_name}</dd>
                </div>
              )}
              {submission.data?.venue_name && (
                <div className="flex justify-between gap-4">
                  <dt className="text-gray-600 flex-shrink-0">Venue</dt>
                  <dd className="font-medium text-gray-900 text-right">{submission.data.venue_name}</dd>
                </div>
              )}
              {submission.data?.add_ons?.length > 0 && (
                <div className="flex justify-between gap-4">
                  <dt className="text-gray-600 flex-shrink-0">Add-ons</dt>
                  <dd className="font-medium text-gray-900 text-right">
                    {submission.data.add_ons.map(a => a.name).join(', ')}
                  </dd>
                </div>
              )}
              <div className="flex justify-between gap-4">
                <dt className="text-gray-600 flex-shrink-0">Date</dt>
                <dd className="font-medium text-gray-900 text-right">
                  {formatDate(submission.date || submission.preferred_date)}
                </dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-gray-600 flex-shrink-0">Time</dt>
                <dd className="font-medium text-gray-900 text-right">
                  {submission.time || submission.preferred_time}
                </dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-gray-600 flex-shrink-0">Guests</dt>
                <dd className="font-medium text-gray-900 text-right">{submission.party_size}</dd>
              </div>
              {submission.total_pence && (
                <div className="flex justify-between gap-4 pt-3 border-t font-bold text-base">
                  <dt className="text-gray-900">Total</dt>
                  <dd className="text-sky-900">{formatPrice(submission.total_pence)}</dd>
                </div>
              )}
            </dl>
          </section>
        </div>

        {/* Contact & Actions */}
        <div className="px-4 py-12 space-y-3">
          {account.phone && (
            <PhoneButton phoneNumber={account.phone}>
              Call {account.name}
            </PhoneButton>
          )}

          <Button
            onClick={() => window.location.href = `/${account.slug}/booking`}
            variant="secondary"
            theme="dark"
            size="lg"
            fullWidth
          >
            Back to {account.name}
          </Button>
        </div>
      </Layout>
    </>
  )
}
